import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { mergeStyleSets, Stack, Text, Link } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../context/context.esm.js';
import { useUserQuery } from '../../../../hooks/useUserQuery.esm.js';

var classNames = mergeStyleSets({
    container: {
        marginRight: 'auto',
        paddingLeft: '24px'
    }
});
var Title = function(param) {
    var dismissPanel = param.dismissPanel;
    var _useContext = useContext(AppContext), _useContext_user = _useContext.user, signedIn = _useContext_user.signedIn, loading = _useContext_user.loading, openSignInModal = _useContext.openSignInModal;
    var displayName = useUserQuery().displayName;
    var t = useTranslation('header').t;
    var headerText = signedIn && displayName ? t('Hi', {
        displayName: displayName
    }) : t('Welcome!');
    return /*#__PURE__*/ jsxs(Stack, {
        horizontal: true,
        className: classNames.container,
        tokens: {
            childrenGap: 10
        },
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "xLarge",
                children: headerText
            }),
            !signedIn && /*#__PURE__*/ jsx(Link, {
                disabled: loading,
                onClick: function() {
                    dismissPanel();
                    openSignInModal === null || openSignInModal === void 0 ? void 0 : openSignInModal();
                },
                children: t('Sign in')
            })
        ]
    });
};

export { Title as default };
